import React from "react";
import Icon from "@ant-design/icons";

const DollarCircleSvg = ({
	width = "1rem",
	height = "1rem",
	fill = "none",
	stroke = "#667085",
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox={`0 0 ${width} ${height}`}
		height={height}
		width={width}
		fill="none"
	>
		<path
			d="M10.6 9.12146C10.2 9.02146 9.8 8.82146 9.5 8.52146C9.2 8.42146 9.1 8.12146 9.1 7.92146C9.1 7.72146 9.2 7.42146 9.4 7.32146C9.7 7.12146 10 6.92146 10.3 7.02146C10.9 7.02146 11.4 7.32146 11.7 7.72146L12.6 6.52146C12.3 6.22146 12 6.02146 11.7 5.82146C11.4 5.62146 11 5.52146 10.6 5.52146V4.12146H9.4V5.52146C8.9 5.62146 8.4 5.92146 8 6.32146C7.6 6.82146 7.3 7.42146 7.4 8.02146C7.4 8.62146 7.6 9.22146 8 9.62146C8.5 10.1215 9.2 10.4215 9.8 10.7215C10.1 10.8215 10.5 11.0215 10.8 11.2215C11 11.4215 11.1 11.7215 11.1 12.0215C11.1 12.3215 11 12.6215 10.8 12.9215C10.5 13.2215 10.1 13.3215 9.8 13.3215C9.4 13.3215 8.9 13.2215 8.6 12.9215C8.3 12.7215 8 12.4215 7.8 12.1215L6.8 13.2215C7.1 13.6215 7.4 13.9215 7.8 14.2215C8.3 14.5215 8.9 14.8215 9.5 14.8215V16.1215H10.6V14.6215C11.2 14.5215 11.7 14.2215 12.1 13.8215C12.6 13.3215 12.9 12.5215 12.9 11.8215C12.9 11.2215 12.7 10.5215 12.2 10.1215C11.7 9.62146 11.2 9.32146 10.6 9.12146ZM10 2.12146C5.6 2.12146 2 5.72146 2 10.1215C2 14.5215 5.6 18.1215 10 18.1215C14.4 18.1215 18 14.5215 18 10.1215C18 5.72146 14.4 2.12146 10 2.12146ZM10 17.0215C6.2 17.0215 3.1 13.9215 3.1 10.1215C3.1 6.32146 6.2 3.22146 10 3.22146C13.8 3.22146 16.9 6.32146 16.9 10.1215C16.9 13.9215 13.8 17.0215 10 17.0215Z"
			fill="#1570EF"
		/>
	</svg>
);
const DollarCircleIcon = (props) => (
	<Icon component={() => <DollarCircleSvg {...props} />} />
);

export default DollarCircleIcon;
